import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getProducts = (params = {}) =>
  client.get("/products", { params }).then((r) => r.data);

export const getProduct = (slug) =>
  client.get(`/products/${slug}`).then((r) => r.data);

export const getRelated = (slug) =>
  client.get(`/products/${slug}/related`).then((r) => r.data);

export const getCategories = () =>
  client.get("/categories").then((r) => r.data);

export const createEnquiry = (payload) =>
  client.post("/enquiries", payload).then((r) => r.data);

export default client;
